import React from 'react';
import { Modal } from 'react-bootstrap';
import FormTextContainer from '../../../redux/containers/FormTextContainer';


class ProviderAccountNumber extends React.Component {
  constructor() {
    super();
    this.state = { showModal: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.popupContent = 'You can usually find your current provider\'s account number in your bill or online account.';
  }

  close() {
    this.setState({ showModal: false });
  }

  open(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div className="current-connection-account-number" >
        <label htmlFor="providerAccountNumber">Please enter the account number with your current provider. <span className="question-mark"><a href="/" onClick={this.open}>?</a></span></label>
        <FormTextContainer
          name="providerAccountNumber"
          placeholder="Please enter your account number here"
          maxLength={80}
          autotestClass="autotest-provider-account-number"
          minLength={4}
          required
        />
        <Modal dialogClassName="skinny-modal" show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton />
          <Modal.Body>
            <p className="skinny-modal-text">
              {this.popupContent}
            </p>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ProviderAccountNumber;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CurrentConnection/ProviderAccountNumber.js
 **/